WiseMetering.Views.LeadConvert = WiseMetering.Views.Modal.Save.extend({
    buttons: ['convert', 'close'],
    className: 'mbx-info text-left',
    template: 'templates/leads/edit',
    form_prefix: 'lead',
    title: () => i18next.t('modal.title.leads.edit'),

    events: {
        'keyup input#organization-name': 'onChangeName',
        'change .input-file': 'changeLogo',
        'change select#country-code': 'changeCountry'
    },

    ui: {
        logoPreviewImage: '.preview-image',
        organizationName: 'input#organization-name',
        PreviewImageSection: '.preview-image-wrapper',
        subdomain: 'input#subdomain',
        timezones: '#timezone'
    },

    changeCountry: function(event) {
        const timezones = WiseMetering.timezones[event.target.value];
        this.ui.timezones.html(timezones.map(tz => `<option value='${tz}'>${tz}</option>`));
    },

    changeLogo: function(event) {
        const [file] = event.target.files;
        if (file) {
            this.ui.PreviewImageSection.show();
            this.ui.logoPreviewImage.attr('src', URL.createObjectURL(file));
            this.logoFile = file;
        }
    },

    convert: function() {
        let data = this.getFormData();

        if (this.logoFile) {
            data.logo = this.logoFile;
        }

        this.modal.block();

        const complete = () => {
            this.$('label').removeClass('err');
            this.$('label').find('.err-help').remove();
            $(this.modal.errors.el).removeClass('active').empty();
        };

        this.model
            .convert(data)
            .done(data => {
                complete();

                if (this.collection) {
                    this.collection.add(data);
                }

                WiseMetering.layout.showTipper('success', i18next.t('ui.successfully_saved'));
                this.modal.close();
            }).fail(xhr => {
                complete();

                let errors = {};
                try {
                    errors = JSON.parse(xhr.responseText);
                } catch (e) {
                }

                _.each(errors.errors, (message, param) => {
                    let errorLabel = this.$(`label[for='${param}']`);

                    if (errorLabel.length === 0) {
                        errorLabel = this.$(`label[for='${this.form_prefix}_${param}']`);
                    }

                    if (errorLabel.length === 0) {
                        errorLabel = this.$(`label[for='${this.form_prefix}_${param}_id']`);
                    }

                    if (errorLabel.length === 0) {
                        errorLabel = this.$(`label[for='${this.form_prefix}-${param}']`);
                    }

                    if (errorLabel.length === 0) {
                        errorLabel = this.$(`label[for='${this.form_prefix}-${param}-id']`);
                    }

                    if (errorLabel.length === 0) {
                        errors.error = message;
                    }

                    errorLabel.addClass('err');
                    errorLabel.append(`<span class="err-help" id="question-${this.form_prefix}_${param}"><i class="${WiseMetering.icons.questionCircle}" aria-hidden='true'></i></span>`);
                    errorLabel.find(`#question-${this.form_prefix}_${param}`).mouseover(() => {
                        $.stt({ target: errorLabel, text: message });
                    });
                    errorLabel.find(`#question-${this.form_prefix}_${param}`).mouseout(() => {
                        $('div.stt').remove();
                    });
                });
                if (errors.error) {
                    $(this.modal.errors.el).addClass('active').html(errors.error);
                }
                this.modal.unblock();
            });
    },

    onChangeName: function() {
        const subdomain = WiseMetering.utils.toSnakeCase(this.ui.organizationName.val());

        this.ui.subdomain.val(subdomain);
    },

    onShow: function() {
        this.onChangeName();

        const timezones = WiseMetering.timezones[this.model.get('country')];
        this.ui.timezones.html(timezones.map(tz => `<option value='${tz}'>${tz}</option>`));

        this.logoFile = null;
        this.ui.PreviewImageSection.hide();
    },

    serializeData: function() {
        const
            json = this.model.toJSON();

        json.allCountries = WiseMetering.countries.toJSON();
        json.allTypes = WiseMetering.organizationTypes;
        json.allCurrencies = WiseMetering.currencies;

        return json;
    }
});
